import { createDashboardFolderSelector } from "./createDashboardFolderSelector";
import { RootState } from "../../../store";

export const createDashboardFolderLoadingSelector = (
  state: RootState,
): boolean => {
  return !!createDashboardFolderSelector(state)?.isLoading;
};
